// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"vendors-node_modules_fortawesome_fontawesome-svg-core_index_mjs":"a8664a","vendors-node_modules_fortawesome_pro-solid-svg-icons_index_mjs":"d8a6e4"}[chunkId] + ".js";
};